import {Test} from '../../../../types';
import {Text} from '@esgi/ui/typography';
import {TestColorIndicator} from '@esgi/main/kits/common';

interface Props {
	item: Test;
}

export function SelectableLisItemContent({item}: Props) {
	return (
		<>
			<TestColorIndicator
				testID={item.id}
				css={{height: 32}}
			/>
			<Text size='small' color='currentColor'>{item.name}</Text>
		</>
	);
}
